import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import UniversalLineWithComponents from '../../components/components/universal_line_with_components/universalLineWithComponents.jsx';
import customText from '../../components/components/custom_text/customText.jsx';

import { ReactComponent as ThreePeople } from '../../components/icons/people.svg';
import { ReactComponent as Play } from '../../components/icons/play.svg';
import { ReactComponent as DolarSquare } from '../../components/icons/dolar-square.svg';
import { ReactComponent as Chart } from '../../components/icons/chart.svg';

import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer
} from 'recharts';
import customButton from "../../components/components/custom_button/customButton";
import ApiService from '../../components/api_services/apiService.jsx';

function StatsDataContainer({ statsData }) {
  // Dane statystyczne podzielone na trzy kolumny
  const { usersStats, trainingsStats, plansStats } = statsData;

  const [chartDataRaw, setChartDataRaw] = useState(null);
  const [chartScope, setChartScope] = useState('weekly');

  const fetchChartStats = async (scope) => {
      try {
          const data = await ApiService.getChartStats(scope);
          // zakładamy strukturę:
          // { activeUsers: { KEY: number, ... }, trainingUsers: { KEY: number, ... } }
          setChartDataRaw(data);
          setChartScope(scope);
      } catch (error) {
          console.error('Błąd pobierania danych wykresu:', error);
      }
  };

  useEffect(() => {
      // pierwsze ładowanie -> tydzień
      fetchChartStats('weekly');
  }, []);

  // mapowanie odpowiedzi z API -> format dla Recharts
  const data = (() => {
      if (!chartDataRaw || !chartDataRaw.activeUsers) {
          return [];
      }

      const { activeUsers, trainingUsers = {} } = chartDataRaw;

      // używamy kluczy z pierwszej mapy (activeUsers)
      return Object.keys(activeUsers).map((key) => ({
          dzien: key,                     // klucz jako etykieta na osi X
          Logowanie: activeUsers[key],    // wartość z activeUsers
          Treningi: trainingUsers[key] ?? 0, // odpowiadająca wartość z trainingUsers (lub 0)
      }));
  })();

  return (
      <>
        <div className="stats-row-container">
          <div className="stats-column">
              <UniversalLineWithComponents
                  basicStyle='line-with-components-without-borders'
                  leftSide={[{

                      component: customText,
                      props: {
                          icon: ThreePeople,
                          text: 'Użytkownicy',
                          baseClass: 'custom-text-header',
                      },
                  }]}
                  rightSide={[]}
              />
            <UniversalLineWithComponents 
              basicStyle='line-with-components-without-borders' 
              leftSide={[{
                component: customText,
                props: {
                  text: 'Zarejestrowani użytkownicy',
                  baseClass: 'custom-text',
                },
              }]} 
              rightSide={[{
                component: customText,
                props: {
                  text: usersStats.registered,
                  baseClass: 'custom-text-negative',
                  borders: 'LRBT'
                },
              }]} 
            />
            <UniversalLineWithComponents 
              basicStyle='line-with-components-without-borders' 
              leftSide={[{
                component: customText,
                props: {
                  text: 'Niepotwierdzone konta',
                  baseClass: 'custom-text',
                },
              }]} 
              rightSide={[{
                component: customText,
                props: {
                  text: usersStats.unconfirmed,
                  baseClass: 'custom-text-negative',
                  borders: 'LRBT'
                },
              }]} 
            />
            <UniversalLineWithComponents 
              basicStyle='line-with-components-without-borders' 
              leftSide={[{
                component: customText,
                props: {
                  text: 'Aktywni użytkownicy',
                  baseClass: 'custom-text',
                },
              }]} 
              rightSide={[{
                component: customText,
                props: {
                  text: usersStats.active,
                  baseClass: 'custom-text-negative',
                  borders: 'LRBT'
                },
              }]} 
            />
              <UniversalLineWithComponents
                  basicStyle='line-with-components-without-borders'
                  leftSide={[{
                      component: customText,
                      props: {
                          text: 'Zablokowani',
                          baseClass: 'custom-text',
                      },
                  }]}
                  rightSide={[{
                      component: customText,
                      props: {
                          text: usersStats.blocked,
                          baseClass: 'custom-text-negative',
                          borders: 'LRBT'
                      },
                  }]}
              />
          </div>
          <div className="stats-column">
              <UniversalLineWithComponents
                  basicStyle='line-with-components-without-borders'
                  leftSide={[{

                      component: customText,
                      props: {
                          icon: Play,
                          text: 'Treningi',
                          baseClass: 'custom-text-header',
                      },
                  }]}
                  rightSide={[]}
              />
            <UniversalLineWithComponents
              basicStyle='line-with-components-without-borders' 
              leftSide={[{
                component: customText,
                props: {
                  text: 'Zaproponowane',
                  baseClass: 'custom-text',
                },
              }]} 
              rightSide={[{
                component: customText,
                props: {
                  text: trainingsStats.proposed,
                  baseClass: 'custom-text-negative',
                  borders: 'LRBT'
                },
              }]} 
            />
            <UniversalLineWithComponents 
              basicStyle='line-with-components-without-borders' 
              leftSide={[{
                component: customText,
                props: {
                  text: 'Zakończone',
                  baseClass: 'custom-text',
                },
              }]} 
              rightSide={[{
                component: customText,
                props: {
                  text: trainingsStats.completed,
                  baseClass: 'custom-text-negative',
                  borders: 'LRBT'
                },
              }]} 
            />
            <UniversalLineWithComponents 
              basicStyle='line-with-components-without-borders' 
              leftSide={[{
                component: customText,
                props: {
                  text: ' ',
                  baseClass: 'custom-text',
                },
              }]} 
              rightSide={[]} 
            />
              <UniversalLineWithComponents
                  basicStyle='line-with-components-without-borders'
                  leftSide={[{
                      component: customText,
                      props: {
                          text: ' ',
                          baseClass: 'custom-text',
                      },
                  }]}
                  rightSide={[]}
              />
          </div>
          <div className="stats-column">
              <UniversalLineWithComponents
                  basicStyle='line-with-components-without-borders'
                  leftSide={[{

                      component: customText,
                      props: {
                          icon: DolarSquare,
                          text: 'Subskrypcja',
                          baseClass: 'custom-text-header',
                      },
                  }]}
                  rightSide={[]}
              />
            <UniversalLineWithComponents 
              basicStyle='line-with-components-without-borders' 
              leftSide={[{
                component: customText,
                props: {
                  text: 'Basic',
                  baseClass: 'custom-text',
                },
              }]} 
              rightSide={[{
                component: customText,
                props: {
                  text: plansStats.basic,
                  baseClass: 'custom-text-negative',
                  borders: 'LRBT'
                },
              }]} 
            />
            <UniversalLineWithComponents 
              basicStyle='line-with-components-without-borders' 
              leftSide={[{
                component: customText,
                props: {
                  text: 'Premium',
                  baseClass: 'custom-text',
                },
              }]} 
              rightSide={[{
                component: customText,
                props: {
                  text: plansStats.premium,
                  baseClass: 'custom-text-negative',
                  borders: 'LRBT'
                },
              }]} 
            />
              <UniversalLineWithComponents
                  basicStyle='line-with-components-without-borders'
                  leftSide={[{
                      component: customText,
                      props: {
                          text: ' ',
                          baseClass: 'custom-text',
                      },
                  }]}
                  rightSide={[]}
              />
              <UniversalLineWithComponents
                  basicStyle='line-with-components-without-borders'
                  leftSide={[{
                      component: customText,
                      props: {
                          text: ' ',
                          baseClass: 'custom-text',
                      },
                  }]}
                  rightSide={[]}
              />
          </div>
        </div>
        <div style={{ width: '100%', height: 400 }}>
            <UniversalLineWithComponents
                basicStyle='line-with-components-without-borders-top-margin'
                leftSide={[{
                    component: customText,
                    props: {
                        icon: Chart,
                        text: 'Aktywność użytkowników',
                        baseClass: 'custom-text-bold',
                    },
                }]}
                rightSide={[
                    {
                        component: customButton,
                        props: {
                            name: 'Tydzień',
                            baseClass: 'custom-button-white-buttons-in-row',
                            activeClass: chartScope === 'weekly' ? 'active-button' : "",
                            hoverClass: 'hover-effect',
                            onClick: () => fetchChartStats('weekly'),
                        },
                    },
                    {
                        component: customButton,
                        props: {
                            name: 'Miesiąc',
                            baseClass: 'custom-button-white-buttons-in-row',
                            activeClass: chartScope === 'monthly' ? 'active-button' : "",
                            hoverClass: 'hover-effect',
                            onClick: () => fetchChartStats('monthly'),
                        },
                    },
                    {
                        component: customButton,
                        props: {
                            name: 'Rok',
                            baseClass: 'custom-button-white-buttons-in-row',
                            activeClass: chartScope === 'yearly' ? 'active-button' : "",
                            hoverClass: 'hover-effect',
                            onClick: () => fetchChartStats('yearly'),
                        },
                    },

                ]}
            />
                <ResponsiveContainer>
            <BarChart
                data={data}
                margin={{
                    top: 20,
                    right: 30,
                    left: 20,
                    bottom: 5,
                }}
            >
                <CartesianGrid strokeDasharray="3 0"   horizontal={true} vertical={false} />
                <XAxis dataKey="dzien" />
                <YAxis scale="linear"
                       tickFormatter={(value) => Math.round(value / 10) * 10 }
                       interval={0}
                       allowDecimals={false}

                />
                <Tooltip cursor={{
                    fill: '#0AE6EB20',
                    radius: [10, 10, 0, 0]
                }}
                />
                <Legend />
                <Bar dataKey="Logowanie" fill="#00868B" name="Aktywni" barSize={20} radius={[4, 4, 0, 0]}
                />
                <Bar dataKey="Treningi" fill="#8DE833" name="Trenujący" barSize={20} radius={[4, 4, 0, 0]}
                />
            </BarChart>
        </ResponsiveContainer></div>
            </>
  );
}

StatsDataContainer.propTypes = {
  statsData: PropTypes.shape({
    usersStats: PropTypes.shape({
      registered: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      unconfirmed: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      active: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    }).isRequired,
    trainingsStats: PropTypes.shape({
      proposed: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      completed: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    }).isRequired,
    plansStats: PropTypes.shape({
      basic: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      premium: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      blocked: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    }).isRequired,
  }).isRequired,
};
export default StatsDataContainer;